(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function updateTimers() {
    var timers = document.querySelectorAll('.garanzie-card__timer');
    var now = new Date();
    timers.forEach(function (el) {
      var hour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
      var minute = parseInt(el.getAttribute('data-cutoff-minute') || '0', 10);
      var cutoff = new Date();
      cutoff.setHours(hour, minute, 0, 0);
      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
        cutoff.setHours(hour, minute, 0, 0);
      }
      var diff = cutoff - now;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = '· ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    });
  }

  function initDots() {
    document.querySelectorAll('.garanzie-section').forEach(function (section) {
      var grid = section.querySelector('.garanzie-section__grid');
      var cards = section.querySelectorAll('.garanzie-card');
      if (!grid || cards.length < 2) return;

      // Crea dots solo se non esistono già
      var existing = section.querySelector('.garanzie-section__dots');
      if (existing) existing.remove();

      var dotsContainer = document.createElement('div');
      dotsContainer.className = 'garanzie-section__dots';

      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'garanzie-section__dot' + (i === 0 ? ' garanzie-section__dot--active' : '');
        dot.setAttribute('aria-label', 'Card ' + (i + 1));
        dot.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
        dotsContainer.appendChild(dot);
      });

      section.appendChild(dotsContainer);

      // Aggiorna dot attivo sullo scroll
      var dots = dotsContainer.querySelectorAll('.garanzie-section__dot');
      grid.addEventListener('scroll', function () {
        var scrollLeft = grid.scrollLeft;
        var cardWidth = cards[0].offsetWidth + 12;
        var active = Math.round(scrollLeft / cardWidth);
        dots.forEach(function (d, i) {
          d.classList.toggle('garanzie-section__dot--active', i === active);
        });
      }, { passive: true });
    });
  }

  function init() {
    updateTimers();
    setInterval(updateTimers, 1000);
    initDots();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();